import * as React from "react";
import { Typeahead } from 'react-bootstrap-typeahead';

import { Vehicle } from "../../../../../models/Vehicle";
import { getVehicleDisplay } from "../../../../utils/draft/Vehicle";
import { Polyglot } from "../../../../../polyglot";
import { TypeaheadEnterEscWrapper } from "../../../TypeaheadEnterEscWrapper";

interface Props
{
    polyglot: Polyglot;
    vehicleId: number;
    vehicles: Vehicle[];
    setVehicle: (vehicleId: number) => void;
}

export const VehicleSelector: React.SFC<Props> = (props: Props) => {
    const { polyglot, vehicleId, vehicles, setVehicle } = props;
    const vehicle = vehicles.find(item => item.id === vehicleId);
    const selectedVehicle = vehicle ? [vehicle] : [];

    return (
        <TypeaheadEnterEscWrapper>
            <Typeahead placeholder={polyglot.t('sensor.placeholder_vehicle')}
                labelKey={getVehicleDisplay} options={vehicles}
                selected={selectedVehicle} onChange={(values: Vehicle[]) => {
                    const id = (values && values.length > 0) ? values[0].id : null
                    setVehicle(id);
                }}
            />
        </TypeaheadEnterEscWrapper>
    );
}; 


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/EditCreateSensor/VehicleSelector.tsx